import getFallbackSectionImage from "@helper/getFallbackSectionImage";
import { type CarouselItem, CarouselItemType } from "@sphtech/sph-web-ui";
import {
  type GalleryCarouselItems,
  GalleryCarouselTypes,
} from "@typings/Opensearch.d";

export default function toCarouselItem(
  item: GalleryCarouselItems[number],
  sectionName: string | undefined,
): CarouselItem | null {
  switch (item.type) {
    case GalleryCarouselTypes.IMAGE:
      return {
        id: item.id || "fallback",
        type: CarouselItemType.IMAGE,
        image: {
          url: item.image?.url || getFallbackSectionImage(sectionName),
          width: item.image?.width,
          height: item.image?.height,
        },
        caption: item.caption,
        credit: item.credit,
        altText: item.altText || item.caption || "Fallback image",
      };

    case GalleryCarouselTypes.BRIGHTCOVE_VIDEO:
      return {
        id: item.id,
        type: CarouselItemType.BRIGHTCOVE_VIDEO,
        videoId: item.videoId,
      };

    case GalleryCarouselTypes.YOUTUBE_VIDEO:
      return {
        id: item.id,
        type: CarouselItemType.YOUTUBE_VIDEO,
        youtubeId: item.youtubeId,
      };

    case GalleryCarouselTypes.UNKNOWN:
      return null;
  }
}
